import { render, staticRenderFns } from "./ChooseGroup.vue?vue&type=template&id=54e2ddec&scoped=true&"
import script from "./ChooseGroup.vue?vue&type=script&lang=js&"
export * from "./ChooseGroup.vue?vue&type=script&lang=js&"
import style0 from "./ChooseGroup.vue?vue&type=style&index=0&id=54e2ddec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e2ddec",
  null
  
)

export default component.exports